import React from "react";
import "./FinancialAuditSolution.css";
import { useLocation } from "react-router-dom";

// ================= ENGLISH DATA
import {
  financialStatementAuditHeading,
  financialStatementAuditData,
  ifrsAdvisoryServiceHeading,
  ifrsAdvisoryServiceData,
  otherAssuranceServiceHeading,
  otherAssuranceServiceData,
  internalControlFrameworkHeading,
  internalControlFrameworkData,
  dealAdvisoryHeading,
  dealAdvisoryData,
  restructuringHeading,
  restructuringData,
  dueDiligenceHeading,
  dueDiligenceData,
  forensicServicesHeading,
  forensicServicesData,
  riskAdvisoryHeading,
  riskAdvisoryData,
  technologyAdvisoryHeading,
  technologyAdvisoryData,
  valuationsHeading,
  valuationsData,
  corporateTaxHeading,
  corporateTaxData,
  mergerAndAcquisitionHeading,
  mergerAndAcquisitionData,
  transferPricingHeading,
  transferPricingData,
  valueAddedTaxHeading,
  valueAddedTaxData,
  internationalTaxHeading,
  internationalTaxData,
  taxRestructuringHeading,
  taxRestructuringData,
  economicSubstanceRegulationsHeading,
  economicSubstanceRegulationsData,
  exciseTaxHeading,
  exciseTaxData,
  financeAndAccountingHeading,
  financeAndAccountingData,
  corporateAdvisoryServicesHeading,
  corporateAdvisoryServicesData,
  expensesClaimManagementHeading,
  expensesClaimManagementData,
  payrollHrServicesHeading,
  payrollHrServicesData,
  secondmentHeading,
  secondmentData,
  treasuryServiceHeading,
  treasuryServiceData,
  marketResearchHeading,
  marketResearchData,
  businessConsultingHeading,
  businessConsultingData,
  entitySetupHeading,
  entitySetupData,
  outsourcedFinanceRegulatoryComplianceHeading,
  outsourcedFinanceRegulatoryComplianceData,
  companySecretarialHeading,
  companySecretarialData,
} from "../../../Data/FinancialAuditSolutionData";

// ================= FRENCH DATA
import {
  financialStatementAuditHeading as financialStatementAuditHeadingFR,
  financialStatementAuditData as financialStatementAuditDataFR,
  ifrsAdvisoryServiceHeading as ifrsAdvisoryServiceHeadingFR,
  ifrsAdvisoryServiceData as ifrsAdvisoryServiceDataFR,
  otherAssuranceServiceHeading as otherAssuranceServiceHeadingFR,
  otherAssuranceServiceData as otherAssuranceServiceDataFR,
  internalControlFrameworkHeading as internalControlFrameworkHeadingFR,
  internalControlFrameworkData as internalControlFrameworkDataFR,
  dealAdvisoryHeading as dealAdvisoryHeadingFR,
  dealAdvisoryData as dealAdvisoryDataFR,
  restructuringHeading as restructuringHeadingFR,
  restructuringData as restructuringDataFR,
  dueDiligenceHeading as dueDiligenceHeadingFR,
  dueDiligenceData as dueDiligenceDataFR,
  forensicServicesHeading as forensicServicesHeadingFR,
  forensicServicesData as forensicServicesDataFR,
  riskAdvisoryHeading as riskAdvisoryHeadingFR,
  riskAdvisoryData as riskAdvisoryDataFR,
  technologyAdvisoryHeading as technologyAdvisoryHeadingFR,
  technologyAdvisoryData as technologyAdvisoryDataFR,
  valuationsHeading as valuationsHeadingFR,
  valuationsData as valuationsDataFR,
  corporateTaxHeading as corporateTaxHeadingFR,
  corporateTaxData as corporateTaxDataFR,
  mergerAndAcquisitionHeading as mergerAndAcquisitionHeadingFR,
  mergerAndAcquisitionData as mergerAndAcquisitionDataFR,
  transferPricingHeading as transferPricingHeadingFR,
  transferPricingData as transferPricingDataFR,
  valueAddedTaxHeading as valueAddedTaxHeadingFR,
  valueAddedTaxData as valueAddedTaxDataFR,
  internationalTaxHeading as internationalTaxHeadingFR,
  internationalTaxData as internationalTaxDataFR,
  taxRestructuringHeading as taxRestructuringHeadingFR,
  taxRestructuringData as taxRestructuringDataFR,
  economicSubstanceRegulationsHeading as economicSubstanceRegulationsHeadingFR,
  economicSubstanceRegulationsData as economicSubstanceRegulationsDataFR,
  exciseTaxHeading as exciseTaxHeadingFR,
  exciseTaxData as exciseTaxDataFR,
  financeAndAccountingHeading as financeAndAccountingHeadingFR,
  financeAndAccountingData as financeAndAccountingDataFR,
  corporateAdvisoryServicesHeading as corporateAdvisoryServicesHeadingFR,
  corporateAdvisoryServicesData as corporateAdvisoryServicesDataFR,
  expensesClaimManagementHeading as expensesClaimManagementHeadingFR,
  expensesClaimManagementData as expensesClaimManagementDataFR,
  payrollHrServicesHeading as payrollHrServicesHeadingFR,
  payrollHrServicesData as payrollHrServicesDataFR,
  secondmentHeading as secondmentHeadingFR,
  secondmentData as secondmentDataFR,
  treasuryServiceHeading as treasuryServiceHeadingFR,
  treasuryServiceData as treasuryServiceDataFR,
  marketResearchHeading as marketResearchHeadingFR,
  marketResearchData as marketResearchDataFR,
  businessConsultingHeading as businessConsultingHeadingFR,
  businessConsultingData as businessConsultingDataFR,
  entitySetupHeading as entitySetupHeadingFR,
  entitySetupData as entitySetupDataFR,
  outsourcedFinanceRegulatoryComplianceHeading as outsourcedFinanceRegulatoryComplianceHeadingFR,
  outsourcedFinanceRegulatoryComplianceData as outsourcedFinanceRegulatoryComplianceDataFR,
  companySecretarialHeading as companySecretarialHeadingFR,
  companySecretarialData as companySecretarialDataFR,
} from "../../../Data/French/FinancialAuditSolutionDataFR";

export default function FinancialAuditSolution({ currentLanguage = "en" }) {
  const location = useLocation();
  const path = location.pathname;
  const isFrench = currentLanguage === "fr";

  // ================= LANGUAGE DATA MAPPING
  const languageHeadings = {
    financialStatementAudit: isFrench ? financialStatementAuditHeadingFR : financialStatementAuditHeading,
    ifrsAdvisoryService: isFrench ? ifrsAdvisoryServiceHeadingFR : ifrsAdvisoryServiceHeading,
    otherAssuranceService: isFrench ? otherAssuranceServiceHeadingFR : otherAssuranceServiceHeading,
    internalControlFramework: isFrench ? internalControlFrameworkHeadingFR : internalControlFrameworkHeading,
    dealAdvisory: isFrench ? dealAdvisoryHeadingFR : dealAdvisoryHeading,
    restructuring: isFrench ? restructuringHeadingFR : restructuringHeading,
    dueDiligence: isFrench ? dueDiligenceHeadingFR : dueDiligenceHeading,
    forensicServices: isFrench ? forensicServicesHeadingFR : forensicServicesHeading,
    riskAdvisory: isFrench ? riskAdvisoryHeadingFR : riskAdvisoryHeading,
    technologyAdvisoryService: isFrench ? technologyAdvisoryHeadingFR : technologyAdvisoryHeading,
    valuations: isFrench ? valuationsHeadingFR : valuationsHeading,
    corporateTax: isFrench ? corporateTaxHeadingFR : corporateTaxHeading,
    mergerAndAcquisition: isFrench ? mergerAndAcquisitionHeadingFR : mergerAndAcquisitionHeading,
    transferPricing: isFrench ? transferPricingHeadingFR : transferPricingHeading,
    valueAddedTax: isFrench ? valueAddedTaxHeadingFR : valueAddedTaxHeading,
    internationalTax: isFrench ? internationalTaxHeadingFR : internationalTaxHeading,
    taxRestructuring: isFrench ? taxRestructuringHeadingFR : taxRestructuringHeading,
    economicSubstanceRegulations: isFrench ? economicSubstanceRegulationsHeadingFR : economicSubstanceRegulationsHeading,
    exciseTax: isFrench ? exciseTaxHeadingFR : exciseTaxHeading,
    financeAndAccounting: isFrench ? financeAndAccountingHeadingFR : financeAndAccountingHeading,
    corporateAdvisoryServices: isFrench ? corporateAdvisoryServicesHeadingFR : corporateAdvisoryServicesHeading,
    expensesClaimManagement: isFrench ? expensesClaimManagementHeadingFR : expensesClaimManagementHeading,
    payrollHrServices: isFrench ? payrollHrServicesHeadingFR : payrollHrServicesHeading,
    secondment: isFrench ? secondmentHeadingFR : secondmentHeading,
    treasuryService: isFrench ? treasuryServiceHeadingFR : treasuryServiceHeading,
    marketResearch: isFrench ? marketResearchHeadingFR : marketResearchHeading,
    businessConsulting: isFrench ? businessConsultingHeadingFR : businessConsultingHeading,
    entitySetup: isFrench ? entitySetupHeadingFR : entitySetupHeading,
    outsourcedFinanceRegulatoryCompliance: isFrench
      ? outsourcedFinanceRegulatoryComplianceHeadingFR
      : outsourcedFinanceRegulatoryComplianceHeading,
    companySecretarial: isFrench ? companySecretarialHeadingFR : companySecretarialHeading,
  };

  const languageData = {
    financialStatementAudit: isFrench ? financialStatementAuditDataFR : financialStatementAuditData,
    ifrsAdvisoryService: isFrench ? ifrsAdvisoryServiceDataFR : ifrsAdvisoryServiceData,
    otherAssuranceService: isFrench ? otherAssuranceServiceDataFR : otherAssuranceServiceData,
    internalControlFramework: isFrench ? internalControlFrameworkDataFR : internalControlFrameworkData,
    dealAdvisory: isFrench ? dealAdvisoryDataFR : dealAdvisoryData,
    restructuring: isFrench ? restructuringDataFR : restructuringData,
    dueDiligence: isFrench ? dueDiligenceDataFR : dueDiligenceData,
    forensicServices: isFrench ? forensicServicesDataFR : forensicServicesData,
    riskAdvisory: isFrench ? riskAdvisoryDataFR : riskAdvisoryData,
    technologyAdvisoryService: isFrench ? technologyAdvisoryDataFR : technologyAdvisoryData,
    valuations: isFrench ? valuationsDataFR : valuationsData,
    corporateTax: isFrench ? corporateTaxDataFR : corporateTaxData,
    mergerAndAcquisition: isFrench ? mergerAndAcquisitionDataFR : mergerAndAcquisitionData,
    transferPricing: isFrench ? transferPricingDataFR : transferPricingData,
    valueAddedTax: isFrench ? valueAddedTaxDataFR : valueAddedTaxData,
    internationalTax: isFrench ? internationalTaxDataFR : internationalTaxData,
    taxRestructuring: isFrench ? taxRestructuringDataFR : taxRestructuringData,
    economicSubstanceRegulations: isFrench
      ? economicSubstanceRegulationsDataFR
      : economicSubstanceRegulationsData,
    exciseTax: isFrench ? exciseTaxDataFR : exciseTaxData,
    financeAndAccounting: isFrench ? financeAndAccountingDataFR : financeAndAccountingData,
    corporateAdvisoryServices: isFrench
      ? corporateAdvisoryServicesDataFR
      : corporateAdvisoryServicesData,
    expensesClaimManagement: isFrench ? expensesClaimManagementDataFR : expensesClaimManagementData,
    payrollHrServices: isFrench ? payrollHrServicesDataFR : payrollHrServicesData,
    secondment: isFrench ? secondmentDataFR : secondmentData,
    treasuryService: isFrench ? treasuryServiceDataFR : treasuryServiceData,
    marketResearch: isFrench ? marketResearchDataFR : marketResearchData,
    businessConsulting: isFrench ? businessConsultingDataFR : businessConsultingData,
    entitySetup: isFrench ? entitySetupDataFR : entitySetupData,
    outsourcedFinanceRegulatoryCompliance: isFrench
      ? outsourcedFinanceRegulatoryComplianceDataFR
      : outsourcedFinanceRegulatoryComplianceData,
    companySecretarial: isFrench ? companySecretarialDataFR : companySecretarialData,
  };

  // ================= PATH TO KEY MAPPING
  const pathMap = {
    "/services/auditandassurance/financialstatementaudit": "financialStatementAudit",
    "/services/auditandassurance/ifrsadvisoryservice": "ifrsAdvisoryService",
    "/services/auditandassurance/otherassuranceservice": "otherAssuranceService",
    "/services/auditandassurance/internalcontrolframework": "internalControlFramework",
    "/services/advisory/dealadvisory": "dealAdvisory",
    "/services/advisory/restructuring": "restructuring",
    "/services/advisory/duediligence": "dueDiligence",
    "/services/advisory/forensicservices": "forensicServices",
    "/services/advisory/riskadvisory": "riskAdvisory",
    "/services/advisory/technologyadvisoryservice": "technologyAdvisoryService",
    "/services/advisory/valuations": "valuations",
    "/services/taxation/corporatetax": "corporateTax",
    "/services/taxation/mergerandacquisition": "mergerAndAcquisition",
    "/services/taxation/transferpricing": "transferPricing",
    "/services/taxation/valueaddedtax": "valueAddedTax",
    "/services/taxation/internationaltax": "internationalTax",
    "/services/taxation/taxrestructuring": "taxRestructuring",
    "/services/taxation/economicsubstanceregulations": "economicSubstanceRegulations",
    "/services/taxation/excisetax": "exciseTax",
    "/services/businessserviceoutsourcing/financeandaccounting": "financeAndAccounting",
    "/services/businessserviceoutsourcing/corporateadvisoryservices": "corporateAdvisoryServices",
    "/services/businessserviceoutsourcing/expensesclaimmanagement": "expensesClaimManagement",
    "/services/businessserviceoutsourcing/payrollhrservices": "payrollHrServices",
    "/services/businessserviceoutsourcing/secondment": "secondment",
    "/services/businessserviceoutsourcing/treasuryservice": "treasuryService",
    "/services/strategies/marketresearch": "marketResearch",
    "/services/strategies/businessconsulting": "businessConsulting",
    "/services/corporateservices/entitysetup": "entitySetup",
    "/services/corporateservices/outsourcedfinanceregulatorycompliance": "outsourcedFinanceRegulatoryCompliance",
    "/services/corporateservices/companysecertarial": "companySecretarial",
  };

  const key = pathMap[path] || "financialStatementAudit";
  const heading = languageHeadings[key];
  const data = languageData[key];

  return (
    <div className="section">
      <div className="text-center">
        <div className="d-flex align-items-center justify-content-center text-center">
          <div className="services-line me-3"></div>
          <p className="service-subtitle mb-0">{heading.subtitle}</p>
        </div>

        <h2 className="service-title">{heading.title}</h2>
        <p className="audit-desc">{heading.description}</p>
      </div>

      <div className="row audit-row">
        {data.map((item, index) => (
          <div className="col-md-3 col-sm-6 audit-col" key={index}>
            <div className="audit-box">
              <h5 className="audit-box-title">{item.title}</h5>
              <p className="audit-box-text mb-0">{item.text}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
